import { css } from "@linaria/core";
import { styled } from "@linaria/react";
import React, {
  useCallback,
  useEffect,
  useLayoutEffect,
  useMemo,
  useState,
} from "react";
import { Text } from "@pages/EverGreen/Components/Text";
import { themeDefault } from "src/theme-revamp";
import { useDispatch } from "react-redux";
import Button from "@components/_Revamp/Button";
import { useAvivaSelector } from "@redux/hook";
import { useHistory, useLocation } from "react-router-dom";
import Contactus from "@pages/EverGreen/Components/Contactus";
import Icon from "@components/_Revamp/Icon";
import MainContainer from "@pages/EverGreen/Components/Container";
import { HOME_URL } from "@static/config";
import { EverGreenStyle } from "@utils/Style/everGreen";
import { clearEverGreenStore, format } from "@pages/EverGreen/Helpers/helpers";
import {
  NotificationBox,
  NotificationContent,
} from "@components/_Revamp/NotificationBox";
import { store } from "@redux/store";
import infoIcon from "@assets/icon/info-gray-solid.svg";
import { cloneDeep } from "lodash";
import { SCREEN_SIZE } from "@static/screen-size";
import { mask } from "@utils/mask";
import { updataStaticData } from "@redux/slices/EVER_GREEN/step1Slice";
import { trackOnSuccess } from "@pages/EverGreen/Helpers/analyticsHelper";

const ThankyouForm = () => {
  const search = useLocation().search;
  const params = new URLSearchParams(search);
  const advisor = params.get("advisor");
  const history = useHistory();
  const dispatch = useDispatch();
  const [planSummary, setPlanSummary] = useState<any>();
  const [screenSize, setScreenSize] = useState(window.innerWidth);

  let everGreenStep1 = cloneDeep(store.getState().everGreenStep1);
  let everGreenStep2 = cloneDeep(store.getState().everGreenStep2);
  let everGreenStep3 = cloneDeep(store.getState().everGreenStep3);
  let everGreenStep4 = cloneDeep(store.getState().everGreenStep4);

  if (
    sessionStorage.getItem("policyConfirmation") &&
    everGreenStep1.quotation.sqsquotation.maturityPayout === -1
  ) {
    const policyData = JSON.parse(
      sessionStorage.getItem("policyConfirmation")!
    );
    everGreenStep1 = policyData.EG1;
    everGreenStep2 = policyData.EG2;
    everGreenStep3 = policyData.EG3;
    everGreenStep4 = policyData.EG4;
    dispatch(updataStaticData(everGreenStep1?.staticData || {}));
  }

  if (!sessionStorage.getItem("policyConfirmation")) {
    const policyData = {
      EG1: store.getState().everGreenStep1,
      EG2: store.getState().everGreenStep2,
      EG3: store.getState().everGreenStep3,
      EG4: store.getState().everGreenStep4,
    };
    sessionStorage.setItem("policyConfirmation", JSON.stringify(policyData));
  }

  let infoData = [
    {
      num: "1",
      text: "We'll process your application within 1 to 2 days.",
    },
    {
      num: "2",
      text: "If no further information is required from you, your policy will be in force.",
    },
    {
      num: "3",
      text: `Stay tuned for an SMS confirmation on your policy.`,
    },
  ];

  if (everGreenStep4.paymentMethod === "srs") {
    infoData = [
      {
        num: "1",
        text: "Your application will be processed within 1-2 working days.",
      },
      {
        num: "2",
        text: "If everything is in order, your policy activates and coverage starts.",
      },
      {
        num: "3",
        text: `Stay tuned for  a confirmation SMS.`,
      },
    ];
  }

  if (everGreenStep4.paymentMethod === "interbank") {
    infoData = [
      {
        num: "1",
        text: "Please complete payment via Interbank Fund Transfer within 21 days using the instructions provided below.",
      },
      {
        num: "2",
        text: "Once payment is received, your application will be processed within 1-2 working days.",
      },
      {
        num: "3",
        text: `If everything is in order, your policy activates and coverage starts. Stay tuned for a confirmation SMS.`,
      },
    ];
  }

  if (everGreenStep4.paymentMethod === "fast") {
    infoData = [
      {
        num: "1",
        text: "Your application will be processed within 1-2 working days.",
      },
      {
        num: "2",
        text: "If everything is in order, your policy activates and coverage starts.",
      },
      {
        num: "3",
        text: `Stay tuned for a confirmation SMS.`,
      },
    ];
  }

  if (everGreenStep4.paymentMethod === "now") {
    infoData = [
      {
        num: "1",
        text: "We'll process your application within 1 to 2 days.",
      },
      {
        num: "2",
        text: "If no further information is required from you, your policy will be in force.",
      },
      {
        num: "3",
        text: `Stay tuned for an SMS confirmation on your policy.`,
      },
    ];
  }

  const planSummaryData = [
    {
      heading: {
        text: "Policy Number",
        value: everGreenStep4.policyNumber,
      },
    },
    {
      heading: {
        text: "Plan",
        value: everGreenStep1.staticData.productName,
      },
    },
    {
      heading: {
        text: "Life Assured",
        value: everGreenStep2.myInfo.fullName,
      },
    },
    {
      heading: {
        text: "Premium Amount",
        value: "S$" + format(everGreenStep1.quotation.investingAmount),
      },
    },
    {
      heading: {
        text: "Premium Frequency",
        value: everGreenStep1.staticData.premiumTerm,
      },
    },
    {
      heading: {
        text: "Policy Term",
        value: everGreenStep1.staticData.policyTerm + " Years",
      },
    },
    {
      heading: {
        text: "Death Benefit",
        value:
          "S$" + format(everGreenStep1.quotation.sqsquotation.deathBenefit),
      },
    },
    {
      heading: {
        text: "Maturity Benefit",
        value:
          "S$" + format(everGreenStep1.quotation.sqsquotation.maturityPayout),
      },
    },
    {
      heading: {
        text: "Premium Payment Mode",
        value:
          everGreenStep4.paymentMethod.toLowerCase() === "interbank"
            ? "Interbank Fund Transfer"
            : everGreenStep4.paymentMethod.toLowerCase() === "fast"
            ? "Interbank Fund Transfer/FAST Transfer"
            : everGreenStep4.paymentMethod.toLowerCase() === "srs"
            ? "Supplementary Retirement Scheme (SRS)"
            : everGreenStep4.paymentMethod.toLowerCase() === "now"
            ? "PayNow"
            : "-",
      },
    },
  ];

  const goToMainWebsite = () => {
    window.open(HOME_URL, "_self");
  };

  const detectScreenWidth = () => {
    setScreenSize(window.innerWidth);
  };
  useEffect(() => {
    window.addEventListener("resize", detectScreenWidth);
    return () => {
      window.removeEventListener("resize", detectScreenWidth);
    };
  }, [screenSize]);

  useEffect(() => {
    if (planSummary === undefined) {
      setPlanSummary(planSummaryData);
    }
  }, [planSummary]);

  useEffect(() => {
    if (planSummary !== undefined) {
      clearEverGreenStore();
      dispatch(updataStaticData(everGreenStep1?.staticData || {}));
    }
  }, [planSummary]);

  useEffect(() => {
    trackOnSuccess({
      acquisitionUpdated: {
        product: {
          prodID: "SDS",
          premiumfrequency: "Single Premium",
          prodName: everGreenStep1.staticData.productName,
          policyID: everGreenStep4.policyNumber,
        },
      },
    });
  }, []);

  return (
    <>
      <MainContainer>
        <FormContainer>
          <FormHeaderContainer>
            <FormHeaderTitleContainer marginHorizontal={"130px"}>
              <Text variant="title" theme={themeDefault} align="center">
                {everGreenStep4.paymentMethod === "now"
                  ? "Application submitted!"
                  : everGreenStep4.paymentMethod === "interbank"
                  ? "Application Submitted! Awaiting Payment."
                  : everGreenStep4.paymentMethod === "fast"
                  ? "Application submitted! Your payment has been successful!"
                  : "Application submitted!"}
              </Text>
            </FormHeaderTitleContainer>
            <FormHeaderDescriptionContainer>
              <Text
                variant="title"
                theme={themeDefault}
                textClass={HeaderDescriptionCss}
              >
                {everGreenStep4.paymentMethod === "now" ? (
                  `We've received your payment. An email with details about your policy application will be sent to you soon.
Here’s what to expect next.`
                ) : everGreenStep4.paymentMethod === "interbank" ? (
                  <>
                    Your policy application details will be emailed to you
                    shortly. Here's what to expect next.
                  </>
                ) : everGreenStep4.paymentMethod === "fast" ? (
                  <>
                    We've received your payment. Your policy application details
                    will be emailed to you shortly. Here's what to expect next.
                  </>
                ) : (
                  <>
                    We've received your payment. Your policy application details
                    will be emailed to you shortly. Here's what to expect next.
                  </>
                )}
              </Text>
            </FormHeaderDescriptionContainer>
          </FormHeaderContainer>
        </FormContainer>

        <FormContentContainer>
          <ULArea>
            {infoData.map((item: any, i: number) => (
              <LIArea key={i} className={item.style}>
                <NumberArea>{item.num}</NumberArea>
                <Text variant="base">{item.text}</Text>
              </LIArea>
            ))}
          </ULArea>
        </FormContentContainer>

        {everGreenStep3.financialAdviser.adviserData.data?.fullName &&
        everGreenStep3.financialAdviser.autoAssignAgent === "own-adviser" ? (
          <InfoContainer>
            <Icon name="evergreen-info-black-filled" className="icon-info" />
            <Text variant="description">
              <span className="name">
                {mask(
                  everGreenStep3.financialAdviser.adviserData.data?.fullName ||
                    ""
                )}
              </span>{" "}
              {`will be your servicing adviser to help you with any queries.`}
            </Text>
          </InfoContainer>
        ) : null}

        {everGreenStep4.paymentMethod.toLowerCase() === "interbank" ? (
          <>
            <SectionContainer data-id="interbank">
              <Text
                variant="title"
                margin="0px 0px 4px 0px"
                color={EverGreenStyle.colors.primary}
              >
                How to pay via Interbank Fund Transfer
              </Text>
              <InterBankInstructionList>
                <li>
                  Log in to your bank's internet banking portal or mobile
                  banking app.
                </li>
                <li>Find the option for Fund Transfer or Payments.</li>
                <li>Select Interbank Fund Transfer.</li>
                <li>
                  Enter Singlife's bank details, transfer amount, and your
                  payment reference number as shown below.
                </li>
              </InterBankInstructionList>
              <Text variant="description" fontWeight={600}>
                You may make payment using the following details:
              </Text>
              <SpiltUpContainer mariginTop="24px">
                <div>
                  <FieldLable>Recipient Bank</FieldLable>
                  <FieldValue>DBS Bank</FieldValue>
                </div>
                <div>
                  <FieldLable>Recipient Name</FieldLable>
                  <FieldValue>Singapore Life Ltd.</FieldValue>
                </div>
                <div>
                  <FieldLable>Recipient Account Number</FieldLable>
                  <FieldValue>
                    {everGreenStep1.staticData.singlifeBankNumber || "-"}
                  </FieldValue>
                </div>

                <div>
                  <FieldLable>Payment Reference (required)</FieldLable>
                  <FieldValue>{everGreenStep4.policyNumber || "-"}</FieldValue>
                </div>
              </SpiltUpContainer>
              <br />
              <NotificationBox
                className={notificationClass}
                margin={"0 0"}
                padding="16px"
                boxShadow={"0"}
              >
                <div>
                  <img src={infoIcon} alt="info icon" />
                  <Text theme={EverGreenStyle} variant="base" fontWeight={600}>
                    Please note that your application will be withdrawn if
                    payment is not received within 21 days.
                  </Text>
                </div>
              </NotificationBox>
            </SectionContainer>
            <br />
          </>
        ) : null}
        <SectionContainer>
          <ListingContainer margin={"0"}>
            <Text
              variant="title"
              margin="0px 0px 50px 0px"
              color={EverGreenStyle.colors.primary}
            >
              Plan Summary
            </Text>
            {planSummary?.map((entries: any) => {
              return (
                <PolicyConfirmationContainer>
                  <span>{entries.heading.text}</span>
                  <span>{entries.heading.value}</span>
                </PolicyConfirmationContainer>
              );
            })}
          </ListingContainer>
        </SectionContainer>

        <FormButtonContainer>
          <Button
            onClick={goToMainWebsite}
            width={"300px"}
            variant={"default"}
            theme={EverGreenStyle}
            label={"Back to Home"}
          ></Button>
        </FormButtonContainer>
        <Contactus
          descriptionClass={descriptionClass}
          findoutLink={{ default: 14, tablet: 14 }}
          color={EverGreenStyle.colors.primary}
          cardLinkClass={{ default: 14, tablet: 14 }}
          cardInfoHeadingClass={font18}
        />
      </MainContainer>
    </>
  );
};

export default ThankyouForm;

const notificationClass = css`
  width: unset;
  border-radius: 16px;
  div {
    display: flex;
    align-items: center;
    gap: 8px;
    width: 100%;
  }
  @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    width: 95%;
    div {
      max-width: unset;
    }
  }
`;

const SectionContainer = styled.div<{ margin?: string; width?: string }>`
  background-color: #ffffff;
  border-radius: 24px;
  opacity: 1;
  -webkit-transition: opacity 0.5s ease-in;
  -moz-transition: opacity 0.5s ease-in;
  -o-transition: opacity 0.5s ease-in;
  -ms-transition: opacity 0.5s ease-in;
  transition: opacity 0.5s ease-in;
  flex-direction: column;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: flex-start;
  transition: all 0.2s ease;
  margin: 0px auto auto;
  padding: 24px 16px;
  scroll-margin-top: 150px;
  white-space: break-spaces;

  & div:last-child {
    border-bottom: 0;
  }
  &[data-id="interbank"] {
    margin-top: 24px;
  }

  @media screen and (min-width: 768px) {
    max-width: 588px;
    margin: auto;
    padding: 24px;
  }
  @media screen and (max-width: 768px) {
    // margin: auto 24px;
  }
  @media screen and (min-width: 1024px) {
    max-width: 792px;
  }

  @media screen and (max-width: 588px) {
    // margin: auto 24px;
  }
`;

const FormContainer = styled.div<FormContainerProps>`
  flex-direction: column;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin: 0 auto;
`;

const ListingContainer = styled.div<FormContainerProps>`
  width: 100%;
  margin: 0 auto;
  & div:last-child {
    margin-bottom: 0;
    padding-bottom: 0;
  }
  @media screen and (min-width: 768px) {
    max-width: 792px;
    margin: ${(props) => (props.margin ? props.margin : "150px auto 0 auto")};
  }
  @media screen and (min-width: 1024px) {
    max-width: 792px;
  }
  @media screen and (max-width: 588px) {
    max-width: 327px;
  }
`;

const FormHeaderContainer = styled.div`
  display: block;
  margin-bottom: 36px;
  padding: 0px 10px;
  @media screen and (min-width: 768px) {
    margin-bottom: 48px;
  }
  @media screen and (max-widh: 588px) {
    max-width: 327px;
  }
`;

const FormContentContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  flex-direction: column;
  column-gap: 30px;
  margin-bottom: 48px;

  @media screen and (max-width: 768px) {
    flex-direction: column;
    margin-bottom: 36px;
  }
`;

const FormHeaderTitleContainer = styled.div<FormHeaderTitleContainerProps>`
  display: block;
  /* margin: 0 ${(props) => props.marginHorizontal}; */
  margin-bottom: 16px;
  width: 100%;
  @media screen and (max-width: 768px) {
    /* padding: 0 20px;
    margin: 0 20px 16px 20px;
    width: 327px; */
  }
`;

const FormHeaderDescriptionContainer = styled.div`
  display: block;
  margin: 0 50px;
  @media screen and (max-width: 768px) {
    margin: 0;
    padding: 0;
  }
`;

const FormButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 64px;
  column-gap: 40px;
  @media screen and (max-width: 767px) {
    column-gap: 0;
    row-gap: 10px;
    margin: 24px auto 0;
    flex-direction: column;
    align-items: center;
    max-width: 327px;
    width: 100%;
  }
`;

const HeaderDescriptionCss = css`
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 140%;
  text-align: center;
  color: #8a8988;
  @media screen and (min-width: 768px) {
    // font-weight: 600;
  }
`;

// stems area
const ULArea = styled.ul`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  padding: 0px;
  gap: 16px;
  isolation: isolate;
  p {
    text-align: center;
  }

  @media screen and (max-width: 588px) {
    display: flex;
    flex-direction: column;
    position: relative;
    margin: auto;
    p {
      text-align: left;
    }
    &:after {
      content: "";
      border: 1px dashed #d8d8d8;
      position: absolute;
      top: 38px;
      bottom: 40px;
      left: 28px;
      z-index: -1;
    }
  }
`;

const LIArea = styled.li`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px;
  gap: 16px;
  flex-basis: 27%;
  border-radius: 24px;
  position: relative;
  &:last-child span:after {
    display: none;
  }

  @media screen and (max-width: 588px) {
    flex-direction: row;
    span {
      justify-content: center;
      align-items: center;
      flex-wrap: wrap;
    }
    p {
      width: 100%;
      align-items: center;
    }
    span:after {
      display: none;
    }
  }
`;

const NumberArea = styled.span`
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 140%;
  display: flex;
  align-items: center;
  text-align: center;
  background: #000;
  color: #fff;
  width: 45px;
  height: 45px;
  justify-content: center;
  border-radius: 50%;
  &:after {
    content: "...";
    position: absolute;
    font-size: 72px;
    top: 10px;
    right: -18px;
    z-index: -1;
    width: 32%;
    letter-spacing: 48px;
  }
  @media screen and (max-width: 588px) {
    position: relative;
    justify-content: flex-start;
    align-items: self-end;
    width: 28.4px;
    height: 24px;
    font-size: 16px;
    text-align: center;
    margin-top: -20px;
    &:before {
      content: "";
      flex-grow: 2;
      height: 2px;
      width: 100%;
    }
  }
`;

const SpiltUpContainer = styled.div<{ mariginTop?: string }>`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  margin-top: 24px;
  column-gap: 20px;
  row-gap: 24px;
  margin-top: ${(props) => props.mariginTop || "60px"};
  & div {
    width: 100%;
    flex-grow: 1;
  }
  @media screen and (max-width: 767px) {
    flex-direction: column;
    margin-top: 24px;
    grid-template-columns: repeat(1, 1fr);
    & div {
      display: flex;
      flex-direction: column;
      width: auto;
      flex-grow: 1;
      column-gap: 15px;
    }
  }
`;

const FieldLable = styled.div`
  font-size: 14px;
  font-weight: 500;
`;

const FieldValue = styled.div`
  font-style: normal;
  line-height: 140%;
  color: #434343;
  margin-top: 16px;
  font-weight: 600;
  font-size: 14px;
  @media screen and (max-width: 767px) {
    margin-bottom: 32px;
    font-size: 14px;
  }
  @media screen and (max-width: ${SCREEN_SIZE.mobilesUp}px) {
    margin-bottom: unset;
    font-size: 14px;
  }
`;

const MessageBoxParagraphCss = css`
  font-family: "Open Sans";
  font-style: normal;
  line-height: 180%;
  color: #444444;
  font-size: 14px;
  font-weight: 500;
  @media screen and (min-width: 768px) {
    font-size: 16px;
    font-weight: 400;
  }
`;

// info styles
const InfoContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: left;
  max-width: 588px;
  margin: auto;
  align-items: start;
  padding: 16px;
  background-color: #ffffff;
  border-radius: 24px;
  margin-bottom: 24px;
  column-gap: 8px;
  .name {
    font-weight: 600;
  }
  p {
    font-size: 14px;
    color: #434343;
  }
  @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    margin-bottom: 24px;
  }
  @media screen and (min-width: 1024px) {
    margin-bottom: 24px;
    max-width: none;
  }
`;

const PolicyConfirmationContainer = styled.div`
  display: flex;
  margin-bottom: 24px;
  padding-bottom: 24px;
  justify-content: space-between;
  border-bottom: 1px solid #f5f5f5;
  & span:nth-child(1) {
    flex-wrap: wrap;
    width: 60%;
    font-weight: 600;
    font-size: 14px;
  }
  & span:nth-child(2) {
    display: flex;
    justify-content: flex-end;
    text-align: right;
    font-weight: 400;
    font-size: 14px;
  }
`;

const descriptionClass = css`
  font-size: 14px;
  font-weight: 600;
`;
const font18 = css`
  font-size: 18px;
`;

export interface FormContainerProps {
  margin?: string;
}

export interface FormHeaderTitleContainerProps {
  marginHorizontal: string;
}

const InterBankInstructionList = styled.ol`
  padding-left: 14px;
  font-size: 14px;
  font-weight: 500;
  line-height: 22.4px;
  margin-bottom: 16px;
`;

const srsli3style = css`
  align-items: center;
  @media screen and (max-width: 588px) {
    align-items: self-end;
  }
`;
